import { CheckIcon, PlusIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@punchup/ui-common/shadcn/ui/tooltip";

import { ComedianAvatar } from "./ComedianAvatar";
import { ComedianName } from "./ComedianName";
import Link from "next/link";
import { cn } from "@punchup/utils/cn";

export default function ComedianAvatarWithLink({
  comedianSlug,
  comedianImgUrl,
  comedianName,
  isNotPunchupComedian = false,
  hideComedianName = false,
  hideFollowIndicator = false,
  size = "sm",
  isFollowed = false,
  className,
  handleComedianSelect,
}: {
  comedianSlug: string;
  comedianImgUrl: string | undefined;
  comedianName: string;
  isNotPunchupComedian?: boolean;
  hideComedianName?: boolean;
  hideFollowIndicator?: boolean;
  size?: "sm" | "md" | "lg";
  isFollowed?: boolean;
  className?: string;
  handleComedianSelect?: (comedianName: string) => void;
}) {
  const isPunchupComedian = !isNotPunchupComedian;

  return (
    <div className={cn("flex items-center gap-x-6", className)}>
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            {isPunchupComedian ? (
              <Link
                href={`/${comedianSlug}`}
                className="relative rounded-full pointer-events-none group"
              >
                <ComedianAvatar
                  comedianImgUrl={comedianImgUrl}
                  comedianName={comedianName}
                  isNotPunchupComedian={isNotPunchupComedian}
                  isFollowed={isFollowed}
                  size={size}
                />
                {!hideFollowIndicator && (
                  <>
                    {isFollowed ? (
                      <div className="absolute bottom-0 -right-2 bg-primary rounded-full w-[26px] h-[26px] flex items-center justify-center">
                        <CheckIcon className="w-[22px] h-[22px] text-white" />
                      </div>
                    ) : null}
                  </>
                )}
              </Link>
            ) : (
              <ComedianAvatar
                comedianImgUrl={comedianImgUrl}
                comedianName={comedianName}
                isNotPunchupComedian={isNotPunchupComedian}
                isFollowed={isFollowed}
                size={size}
              />
            )}
          </TooltipTrigger>
          <TooltipContent sideOffset={10} className="hidden text-base md:block">
            {comedianName}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <ComedianName
        comedianName={comedianName}
        size={size}
        hide={hideComedianName}
        className="pl-2 md:pl-4 cursor-pointer"
        handleComedianSelect={handleComedianSelect}
      />
    </div>
  );
}
